export const LOCAL_INSURER_PHONE = 'DEFAULT_INSURER_PHONE'
export const LOCAL_ECONOMIC_NUMBER = 'DEFAULT_ECONOMIC_NUMBER'
